import React from 'react';
import { moderateScale } from 'react-native-size-matters';
import PropTypes from 'prop-types';
import { Text, View, StyleSheet, TouchableOpacity } from 'react-native';

import Theme from '../../theme';
import { Icon } from '../../components';
import { mappedTitles, mappedIcons } from '../../WorkoutGoalAssistant/utils';

const LongTermFitnessGoal = ({ t, goal, onPress }) => (
  <View style={styles.goalContainer}>
    <View style={styles.longTermGoalContainer}>
      <View style={styles.iconContainer}>
        {mappedIcons[goal]({}, Theme.BLACK)}
      </View>
      <View>
        <Text style={styles.fitnessGoalText}>{t('workoutGoals:longTermFitnessGoal')}</Text>
        <Text style={styles.finessGoalTitle}>{mappedTitles[goal].toUpperCase()}</Text>
      </View>
      {onPress &&
        <TouchableOpacity style={styles.settingsIcon} onPress={onPress}>
          <Icon
            size={25}
            color={Theme.PRIMARY}
            name="ios-settings"
          />
        </TouchableOpacity>
      }
    </View>
    <View style={styles.lineSeparator} />
  </View>
);

LongTermFitnessGoal.propTypes = {
  t: PropTypes.func.isRequired,
  goal: PropTypes.string.isRequired,
  onPress: PropTypes.func
};

const styles = StyleSheet.create({
  settingsIcon: {
    marginLeft: 'auto',
  },
  fitnessGoalText: {
    fontWeight: 'normal',
    color: Theme.CHARCOAL,
  },
  finessGoalTitle: {
    fontWeight: 'bold',
    color: Theme.CHARCOAL,
  },
  longTermGoalContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  iconContainer: {
    marginRight: 5,
    width: moderateScale(27, 2),
    height: moderateScale(24, 2),
  },
  goalContainer: {
    paddingVertical: 10,
  },
  lineSeparator: {
    height: 2,
    marginTop: 10,
    backgroundColor: Theme.GREY_LIGHT,
  },
});

export default LongTermFitnessGoal;
